// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zR4R","tabsBox":"styles_tabsBox__1Ws0K","createButton":"styles_createButton__1DikQ"};